import { BANK_VIEWS, type BankView } from '@brickup/shared/utils'
import { oneOf, stringFilter } from '@/components/Internal/DataTable'

export const bankListFilters = {
  // The work is in the open pile, so the list opens on it.
  view: oneOf<BankView>([...BANK_VIEWS], 'OPEN'),
  // The pile is in memory; the match runs here.
  search: stringFilter(),
}
